import { Component, OnInit, Input, HostBinding, ChangeDetectionStrategy, ElementRef, Renderer2 } from '@angular/core';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-column-group',
  templateUrl: './column-group.component.html',
  styleUrls: ['./column-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnGroupComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  public get isActive() {
    return this._isActive;
  }
  public set isActive(value) {
    this._isActive = value;
    this.show(this.isActive);
  }
  private _isActive = false;
  
  constructor(
    private renderer: Renderer2,
    private element: ElementRef
  ) {}


  ngOnInit() {
  }

  show(show: boolean) {
    const style = this.isActive ? 'flex' : 'none';
    // const this.sanitizer.bypassSecurityTrustStyle(style);
    this.renderer.setStyle(this.element.nativeElement, 'display', style);
  }

}
